import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { AlertProvider } from '@lendica/components';
import { theme } from './theme';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
    dsn: 'https://0ad5a2205209483cb46658f73d83fcb2@o4503999349522432.ingest.sentry.io/4503999356993536',
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
});

const root = createRoot(document.getElementById('app')!);

root.render(
    <BrowserRouter>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AlertProvider>
                <App />
            </AlertProvider>
        </ThemeProvider>
    </BrowserRouter>
);
